import React from 'react';
import ContainerHeader from 'components/ContainerHeader/index';
import {PostData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostData';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import Button from 'material-ui/Button';

class DriversDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            driverDetail : [],
            first_name : '',
            last_name : '',
            mobile : '',
            address : '',
            panCard : '',
            gender : '',
            license_no : '',
            id:'',
            email:'',
            showprofile : false,
            edit:false,
            user_type:'D',
            engine_no:'',
            registration:'',
            make:'',
            color:'',
            model:'',
            fuel_type:'',
            car_type:'',
            uid:'',
            seats:0,
            acct_no:'',
            ifsc:'',
            acct_holder:'',
            bank_name:'',
            branch:'',
        };
        this.doBack = this.doBack.bind(this);
        this.editProfile = this.editProfile.bind(this);
        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);

    }
    componentDidMount() {
        this.showAllDrivers();
    }
    /*componentDidUpdate() {
        this.showAllDrivers();
    }*/
    showAllDrivers() {
        console.log("ggggggggggggggggggggggggggg");
        PostData('allusers', {type:"D"}).then((result) => {
            this.setState({driverDetail:result.Response.Data.user});
            console.log(this.state);
        });

    }
    save() {
        this.setState({edit: !this.state.edit});
        console.log("saving===",this.state);
        PostData('update', this.state).then((result) => {
            console.log("XXXXXXXXXXX===", result.user);
            this.setState({profileData: result.user});
        });
    }
    onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }
    showDetails(id, e) {
        console.log("id===========",id);
        PostData('profile', {id:id}).then((result) => {
            console.log("FIRST NAME:::::",result.user.first_name);
            this.setState({
                            first_name: result.user.first_name,
                            last_name: result.user.last_name,
                            mobile: result.user.mobile,
                            address: result.user.address,
                            panCard: result.user.panCard,
                            gender: result.user.gender,
                            license_no: result.user.license_no,
                            id: result.user.id,
                            email:result.user.email,
                            engine_no:result.user.engine_no,
                            registration:result.user.registration,
                            make:result.user.make,
                            color:result.user.color,
                            model:result.user.model,
                            fuel_type:result.user.fuel_type,
                            car_type:result.user.car_type,
                            uid:result.user.uid,
                            seats:result.user.seats,
                            acct_no:result.user.acct_no,
                            ifsc:result.user.ifsc,
                            acct_holder:result.user.acct_holder,
                            bank_name:result.user.bank_name,
                            branch:result.user.branch,
                            showprofile: !this.state.showprofile,
                        });
        });
    }
    editProfile() {
        this.setState({edit: !this.state.edit});
    }
    doBack() {
        this.setState({showprofile: !this.state.showprofile});
    }
    showAll() {
        return(
            <Table>
                <TableHead className="mb-4">
                    <TableRow>
                        Drivers Link:
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.driverDetail.map(n => {
                        return (
                            <TableRow key={n.id}>
                                <Button href="javascript:void(0)" onClick={(e) => this.showDetails(n.id, e)}>
                                    <span className="nav-text">{n.first_name+" "+n.last_name}</span>
                                </Button>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
        
    }
    editData() {
        return (
            
            <Table>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colSpan= "2">
                            <h2>Welcome {this.state.first_name+" "+this.state.last_name} !!</h2>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>
                            <input type="text" name = "first_name" value={this.state.first_name} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Last Name</TableCell>
                        <TableCell>
                            <input type="text" name = "last_name" value={this.state.last_name} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Gender</TableCell>
                        <TableCell>
                            <input type="text" name = "gender" value={this.state.gender} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>
                            <input type="text" name = "address" value={this.state.address} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pan Card</TableCell>
                        <TableCell>
                            <input type="text" name = "panCard" value={this.state.panCard} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>License No.</TableCell>
                        <TableCell>
                            <input type="text" name = "license_no" value={this.state.license_no} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>
                            <input type="text" name = "email" value={this.state.email} className="form-control form-control-lg" />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Mobile Number</TableCell>
                        <TableCell>
                            <input type="text" name = "mobile" value={this.state.mobile} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Engine Number</TableCell>
                        <TableCell>
                            <input type="text" name = "engine_no" value={this.state.engine_no} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Registration No.</TableCell>
                        <TableCell>
                            <input type="text" name = "registration" value={this.state.registration} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Name</TableCell>
                        <TableCell>
                            <input type="text" name = "make" value={this.state.make} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Color</TableCell>
                        <TableCell>
                            <input type="text" name = "color" value={this.state.color} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Model</TableCell>
                        <TableCell>
                            <input type="text" name = "model" value={this.state.model} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>


                    <TableRow>
                        <TableCell>Vehicle Fuel Type</TableCell>
                        <TableCell>
                            <input type="text" name = "fuel_type" value={this.state.fuel_type} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>
                            <input type="text" name = "car_type" value={this.state.car_type} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Adhaar Card</TableCell>
                        <TableCell>
                            <input type="text" name = "uid" value={this.state.uid} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>No. of seats</TableCell>
                        <TableCell>
                            <input type="number" name = "seats" value={this.state.seats} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Account Number</TableCell>
                        <TableCell>
                            <input type="text" name = "acct_no" value={this.state.acct_no} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>IFSC Code</TableCell>
                        <TableCell>
                            <input type="text" name = "ifsc" value={this.state.ifsc} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>Account Holder Name</TableCell>
                        <TableCell>
                            <input type="text" name = "acct_holder" value={this.state.acct_holder} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Bank Name</TableCell>
                        <TableCell>
                            <input type="text" name = "bank_name" value={this.state.bank_name} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Bank Branch</TableCell>
                        <TableCell>
                            <input type="text" name = "branch" value={this.state.branch} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                </TableBody>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colSpan= "2">
                            <button className="btn jr-btn-rounded btn-primary btn-rounded" onClick={this.save}>
                                Save
                            </button>
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>
        );
    }
    displayProfile() {
        return(
            <Table>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colSpan= "2">
                            <h2>Welcome {this.state.first_name+" "+this.state.last_name} !!</h2>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>{this.state.first_name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Last Name</TableCell>
                        <TableCell>{this.state.last_name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Gender</TableCell>
                        <TableCell>{this.state.gender}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>{this.state.address}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pan Card</TableCell>
                        <TableCell>{this.state.panCard}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>License No.</TableCell>
                        <TableCell>{this.state.license_no}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Email Id</TableCell>
                        <TableCell>{this.state.email}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Mobile Number</TableCell>
                        <TableCell>{this.state.mobile}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Engine Number</TableCell>
                        <TableCell>{this.state.engine_no}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Registration No.</TableCell>
                        <TableCell>{this.state.registration}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Name</TableCell>
                        <TableCell>{this.state.make}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Color</TableCell>
                        <TableCell>{this.state.color}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Model</TableCell>
                        <TableCell>{this.state.model}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Fuel Type</TableCell>
                        <TableCell>{this.state.fuel_type}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>{this.state.car_type}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Adhaar Card</TableCell>
                        <TableCell>{this.state.uid}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>No. of seats</TableCell>
                        <TableCell>{this.state.seats}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Account Number</TableCell>
                        <TableCell>{this.state.acct_no}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>IFSC Code</TableCell>
                        <TableCell>{this.state.ifsc}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Account Holder Name</TableCell>
                        <TableCell>{this.state.acct_holder}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Bank Name</TableCell>
                        <TableCell>{this.state.bank_name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Bank Branch</TableCell>
                        <TableCell>{this.state.branch}</TableCell>
                    </TableRow>
                </TableBody>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell>
                            <button className="btn jr-btn-rounded btn-primary btn-rounded"  onClick={this.doBack}>
                                Back
                            </button>
                        </TableCell>
                        <TableCell>
                            <button className="btn jr-btn-rounded btn-primary btn-rounded" onClick ={this.editProfile}>
                                Edit Profile
                            </button>
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>
        );
    }
    render() {
        return(
            <div className="animated slideInUpTiny animation-duration-3">
                <ContainerHeader match={this.props.match} title="Drivers Details"/>
                <div className="table-responsive-material">
                    {!this.state.edit && !this.state.showprofile && this.showAll()}
                    {this.state.showprofile && !this.state.edit && this.displayProfile()}
                    {this.state.showprofile && this.state.edit && this.editData()}
                </div>
            </div>
        );
    }
}

export default DriversDetails;


// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/DriversDetails/index.js